import styled from "styled-components";
const HEADING_STYLES = {
  small: (theme) => ({
    color: theme.color.black7,
    fontSize: theme.fontSize.sm,
    fontWeight: theme.fontWeight.semiBold,
    letterSpacing: "0.015em",
    lineHeight: theme.lineHeight.sm,
    textTransform: "uppercase"
  }),
  medium: (theme) => ({
    color: theme.color.black9,
    fontSize: theme.fontSize.md,
    fontWeight: theme.fontWeight.medium,
    lineHeight: theme.lineHeight.md
  }),
  large: (theme) => ({
    color: theme.color.black9,
    fontSize: theme.fontSize.lg,
    fontWeight: theme.fontWeight.medium,
    lineHeight: theme.lineHeight.lg
  }),
  xlarge: (theme) => ({
    color: theme.color.black9,
    fontSize: theme.fontSize.xl,
    fontWeight: theme.fontWeight.semiBold,
    lineHeight: theme.lineHeight.xl
  })
};
const HeadingImpl = styled("h1")(
  {
    margin: 0,
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  ({ theme, $size }) => {
    var _a;
    return (_a = HEADING_STYLES[$size]) == null ? void 0 : _a.call(HEADING_STYLES, theme);
  },
  ({ $noWrap }) => $noWrap ? {
    whiteSpace: "nowrap"
  } : void 0
);
export {
  HeadingImpl
};
